<template>
	<div class="crema-link-account">
		<Selector v-model="brandId" title="브랜드" :optionList="brandIdList" />
		<button
			:disabled="!brandId"
			class="btn blue crema-link-account__button"
			v-text="'확인'"
			@click="linkAccount"
		/>
	</div>
</template>
<script>
	import { mapState } from 'vuex';
	import Selector from '@/components/Selector.vue';

	export default {
		name: 'CremaLinkAccount',
		components: {
			Selector,
		},
		data() {
			const brandIdListDefault = { value: null, name: '브랜드 선택' };
			return {
				brandIdListDefault,
				brandIdList: [brandIdListDefault],
				brandId: null,
				brandList: [],
			};
		},
		computed: {
			...mapState({
				cb: state => state.modal.params.cb,
			}),
		},
		methods: {
			async brandIdListSet() {
				try {
					const { data } =
						await this.$axiosAdmin2.get('/api/crema/brands');
					this.brandIdList = [
						this.brandIdListDefault,
						...data.brands.map(item => ({
							value: item.id,
							name: item.name,
						})),
					];
					this.brandList = data.brands;
				} catch (err) {
					console.error(err);
					alert('브랜드목록을 불러오는데 실패했습니다.');
				}
			},
			linkAccount() {
				if (!confirm('해당 브랜드와 매칭시키겠습니까?')) return;
				const target = this.brandList.find(
					item => item.id === this.brandId
				);
				this.cb({
					brandId: target.id,
					brandCode: target.code,
				});
			},
		},
		created() {
			this.brandIdListSet();
		},
	};
</script>
<style lang="scss" scoped>
	.crema-link-account {
		display: flex;
		align-items: flex-end;
		justify-content: space-between;

		&__button {
			margin-bottom: 3px;
		}
	}
</style>
